import { Component } from '@theme/component';

/**
 * Opens Shopify's native preferences panel without changing consent itself.
 * @typedef {object} Refs
 * @property {HTMLButtonElement} opener
 * @property {HTMLElement} status
 * @extends {Component<Refs>}
 */
class CookiePreferences extends Component {
  requiredRefs = ['opener', 'status'];
  #request;

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#request?.abort();
  }

  openPreferences = async () => {
    this.#request?.abort();
    const request = new AbortController();
    this.#request = request;
    this.refs.status.textContent = '';
    this.refs.opener.setAttribute('aria-busy', 'true');
    try {
      for (let attempt = 0; !window.privacyBanner?.showPreferences && attempt < 20; attempt++) {
        await new Promise((resolve) => {
          const finish = () => {
            clearTimeout(timer);
            request.signal.removeEventListener('abort', finish);
            resolve();
          };
          const timer = setTimeout(finish, 250);
          request.signal.addEventListener('abort', finish, { once: true });
        });
        if (request.signal.aborted) return;
      }
      if (!window.privacyBanner?.showPreferences) throw new Error('Privacy banner unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      if (this.isConnected && !request.signal.aborted) this.refs.status.textContent = this.dataset.error;
    } finally {
      if (this.isConnected && !request.signal.aborted) this.refs.opener.removeAttribute('aria-busy');
      if (this.#request === request) this.#request = undefined;
    }
  };
}

if (!customElements.get('zu-cookie-preferences')) customElements.define('zu-cookie-preferences', CookiePreferences);
